var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5052 26.9354C21.8587 27.3596 22.4893 27.417 22.9136 27.0634C23.3379 26.7098 23.3952 26.0793 23.0416 25.655L21.5052 26.9354ZM16.7491 19.666L15.9809 19.0258C15.6718 19.3967 15.6718 19.9353 15.9809 20.3062L16.7491 19.666ZM23.0416 13.677C23.3952 13.2527 23.3379 12.6222 22.9136 12.2686C22.4893 11.915 21.8587 11.9724 21.5052 12.3966L23.0416 13.677ZM23.0416 25.655L17.5173 19.0258L15.9809 20.3062L21.5052 26.9354L23.0416 25.655ZM17.5173 20.3062L23.0416 13.677L21.5052 12.3966L15.9809 19.0258L17.5173 20.3062ZM20.5 6C28.232 6 34.5 12.268 34.5 20L36.5 20C36.5 11.1634 29.3366 4 20.5 4L20.5 6ZM34.5 20C34.5 27.732 28.232 34 20.5 34L20.5 36C29.3366 36 36.5 28.8366 36.5 20L34.5 20ZM20.5 34C12.768 34 6.5 27.732 6.5 20L4.5 20C4.5 28.8366 11.6634 36 20.5 36L20.5 34ZM6.5 20C6.5 12.268 12.768 6 20.5 6L20.5 4C11.6634 4 4.5 11.1634 4.5 20L6.5 20Z",
    fill: "#302F2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.9058487dc5b017157982ef0d10c866d4.svg";
export { ForwardRef as ReactComponent };